<template>
  <div class="hidden md:flex flex-wrap gm-nav-tabs">
    <button
      v-for="(tab, index) in filteredNavTabs"
      :key="index"
      type="button"
      class="gm-nav-tabs__item"
      :class="{ 'is-active': currentTabIndex === index }"
      :aria-current="currentTabIndex === index ? 'page' : null"
      @click="redirectToPage(tab,index)"
    >
      {{ $t(tab.tabName) }}
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentTabIndex: -1,
    };
  },

  props: {
    nav_tabs: {
      required: false,
    },
  },

  methods: {
    redirectToPage(tab, index) {
      this.currentTabIndex = index;
      if (tab.tabRoute === 'Settings') {
        this.$router
          .replace({ name: tab.tabRoute, query: tab.tabQuery })
          .catch(() => {});
      } else {
        if (tab.tabQuery) {
          this.$router
            .push({ name: tab.tabRoute, query: tab.tabQuery })
            .catch(() => {});
        } else {
          this.$router.push({ name: tab.tabRoute }).catch(() => {});
        }
      }
    },
  },

  computed: {
    // Returns filtered navigation tabs data for with empty tabs removed
    filteredNavTabs() {
      return this.nav_tabs.filter(tab => tab !== '');
    }
  },

  mounted() {
    const tabIndex = this.nav_tabs.findIndex((ele) => {
      if (ele.tabRoute === 'Settings') {
        return ele.tabQuery.type === this.$route.query.type;
      }
      
      return ele.tabRoute === this.$route.name;
    });
    this.currentTabIndex = tabIndex;
  },
};
</script>

<style scoped>
/* Segmented route tabs (design system §3.9). Display stays with the
   hidden / md:flex utilities so the mobile behaviour is unchanged. */
.gm-nav-tabs {
  gap: 4px;
  align-items: center;
  padding: 4px;
  background: var(--gs-surface-subtle);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
}

.gm-nav-tabs__item {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  margin: 0;
  padding: 0 14px;
  color: var(--gs-muted-foreground);
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--gs-radius-sm);
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease;
}

.gm-nav-tabs__item:hover {
  color: var(--gs-foreground);
  background: var(--gs-muted);
}

.gm-nav-tabs__item:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--gs-ring);
}

.gm-nav-tabs__item.is-active {
  color: var(--gs-active);
  background: var(--gs-active-soft);
  border-color: var(--gs-active-border);
}
</style>
